import { Box } from '@mui/system';
import { BundlePrice } from 'components/BundlePrice';
import { BundleProps } from 'utils/types';
import { EBundlesInternalViewModel } from 'utils/enums';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { StyledFabelTownBundle } from './style';

const MAX_PRODUCTS = 4;

export const FabelTownBundle: React.FC<BundleProps> = ({
    prices,
    productList,
    backgroundSrc,
    backgroundColor = { colorOne: '#D771BE', colorTwo: '#C151E1' },
    salePercentage = 0,
    borderRadius,
}) => {
    const products = (productList || []).slice(0, MAX_PRODUCTS);
    const imageSize = products.length === 1 ? 72 : 40;
    const mainProduct = products.length > 0 ? products[0] : { textFontColorHex: '#fff' };

    return (
        <StyledFabelTownBundle
            mainProductColor={mainProduct.textFontColorHex || '#fff'}
            backgroundSrc={backgroundSrc}
            backgroundColor={backgroundColor}
            className="internal-bundle"
            isSale={!!salePercentage}
            borderRadius={borderRadius || 15}
            imageSize={imageSize}
            products={products}
        >
            <Box className="container">
                <Box className="product">
                    <Box className="decorative-block">
                        {products.map((product, index) => (
                            <Box key={index} className="product-container">
                                {/* Product Image */}
                                <Box className="image-container">
                                    <img
                                        className="image"
                                        src={product.images?.product || ''}
                                        alt="product"
                                    />
                                </Box>

                                {/* Product Quantity with Original Price Crossed Out */}
                                <Box className="amount-container">
                                    <AutoTextSize
                                        mode="oneline"
                                        maxFontSizePx={14}
                                        className="main-amount"
                                    >
                                        {product.quantityDisplay}
                                    </AutoTextSize>
                                    {product.strokedSaleQuantity && (
                                        <AutoTextSize
                                            mode="oneline"
                                            maxFontSizePx={10}
                                            className="crossed-amount"
                                        >
                                            {product.strokedSaleQuantity}
                                        </AutoTextSize>
                                    )}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                    <Box className="price-container">
                        <BundlePrice
                            prices={prices}
                            type={EBundlesInternalViewModel.FABEL_TOWN}
                            textShadow="0 0 4px #205BA5"
                        />
                    </Box>
                </Box>
            </Box>
        </StyledFabelTownBundle>
    );
};
